import React from 'react';
import { Charge } from '../core/_models';

interface Props {
  charge: Charge | null;
  show: boolean;
  onHide: () => void;
  onConfirm: (chargeId: string) => void;
  isLoading?: boolean;
}

export const ChargeCancelModal: React.FC<Props> = ({ charge, show, onHide, onConfirm, isLoading }) => {
  if (!show || !charge) return null;

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1} role='dialog' aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>Cancelar Cobrança</h2>
              <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={onHide}>
                <i className='bi bi-x fs-1'></i>
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='text-center mb-13'>
                <h1 className='mb-3'>Deseja realmente cancelar esta cobrança?</h1>
                <div className='text-muted fw-bold fs-5'>
                  A cobrança será removida do gateway de pagamento e o cliente não poderá mais pagá-la.
                </div>
              </div>

              <div className='d-flex flex-stack bg-light rounded p-4 mb-8'>
                <div className='d-flex flex-column'>
                  <span className='fw-bolder text-gray-800 fs-5'>{charge.client?.user?.name || charge.client?.nameResponsible || charge.client_name || 'Desconhecido'}</span>
                  <span className='text-muted fw-bold'>ID: {charge.id.toUpperCase()}</span>
                </div>
                <div className='d-flex flex-column align-items-end'>
                  <span className='fw-bolder text-gray-800 fs-5'>R$ {Number(charge.gross_value).toFixed(2).replace('.', ',')}</span>
                  <span className='text-muted fw-bold'>Venc.: {new Date(charge.due_date).toLocaleDateString('pt-BR')}</span>
                </div>
              </div>

              <div className='text-center pt-10'>
                <button type='reset' className='btn btn-light me-3' onClick={onHide}>
                  Voltar
                </button>
                <button
                  type='button'
                  className='btn btn-danger'
                  onClick={() => onConfirm(charge.id)}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Aguarde... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label'>Sim, Cancelar Cobrança</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};
